// extracted by mini-css-extract-plugin
export default {"sidebar":"SideBar_sidebar__32CMa"};